import React from 'react';

import { Card } from '@sogei/react-web-components-catalog'

class Help extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const assistenzaFisconline =
      <>
        <p>Servizio attivo dal lunedì al venerdì: 9 - 17, il sabato: 9 - 13 (festività nazionali escluse).</p>
        <div className="row">
          <div className="col-12 col-md-4"><p>da fisso:</p></div>
          <div className="col-12 col-md-8"><p><a href="tel:+39848800444"><strong>848 800 444</strong></a> (tariffa urbana a tempo)</p></div>
        </div>
        <div className="row">
          <div className="col-12 col-md-4"><p>da cellulare:</p></div>
          <div className="col-12 col-md-8"><p><a href="tel:+390696668907"><strong>06 96668907</strong></a> (costo in base al piano tariffario del proprio gestore)</p></div>
        </div>
        <div className="row">
          <div className="col-12 col-md-4"><p>dall'estero:</p></div>
          <div className="col-12 col-md-8"><p><a href="tel:+390696668933"><strong>0039 0696668933</strong></a> (costo a carico del chiamante)</p></div>
        </div>
      </>

    const assistenzaEntratel =
      <>
        <p>Servizio attivo dal lunedì al venerdì: 9 - 18; sabato: 9 - 14; (festività nazionali escluse).</p>
        <p>Si richiede il numero identificativo presente nella parte esterna della busta consegnata dall'Agenzia delle Entrate (contrassegnato dalla lettera "A") che inizia con il "9" (ad esempio, 92200033).</p>
        <p>da fisso e da cellullare: <a href="tel:+39848836526"><strong>848 836 526</strong></a> (costo di una telefonata urbana)</p>
      </>

    return (
      <div className="container-fluid py-3 py-md-4">
        <h1>Assistenza tecnica per utilizzo dei Servizi Telematici</h1>
        <div className="row">
          <div className="col-12 col-md-6 col-xl-4">
            <Card title="Assistenza telefonica per Fisconline" cardType="default" body={assistenzaFisconline}></Card>
          </div>
          <div className="col-12 col-md-6 col-xl-4">
            <Card title="Assistenza telefonica per Entratel" cardType="default" body={assistenzaEntratel}></Card>
          </div>
          <div className="col-12 col-md-6 col-xl-4">
          </div>
        </div>
      </div>
    );
  }

}

export default Help;